import React, { Component, createRef } from "react";

import { Button, Card, CardBody, Col, Container, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import BootstrapTable from "react-bootstrap-table-next";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  addSalesExpressInward,
  getCategories,
  getPartyApi,
  getUnitAPI,
  getUserApi,
  updateExpressInward,
  getExpressInwardById,
  getDataEntryOutwards,
  addPartyOutwards,
  getPartyOutwards,
} from "api";
import OutwardFormModal from "../Common/OutwardFormModal";
import moment from "moment";

class AddExpressInward extends Component {
  constructor(props) {
    console.log("rr", props);
    super(props);
    this.state = {
      ...this.props,
      validation: "",
      partyList: [],
      factoryList: [],
      categoryList: [],
      deliveryBoyList: [],
      stockList: [], // Initialize stockList as an empty array
      dataEntryOutwardsList: [], // <-- add this
      partyOutwardsList: [], // <-- add this for OutWard To Party
      submitDisabled: false,
      selectedParty:
        "query" in props.location
          ? props.location.query.data.partyId
          : {
              id: "",
              contactPersonName: "",
              mobileNo1: "",
              mobileNo2: "",
              email: "",
            },
      factoryId:
        "query" in props?.location
          ? props?.location?.query?.data?.factoryId
          : "",
      categoryId:
        "query" in props?.location
          ? props?.location?.query?.data?.categoryId
          : "",

      partyId:
        "query" in props?.location ? props?.location?.query?.data?.partyId : "",

      pieces:
        "query" in props?.location
          ? props?.location?.query?.data?.noOfPieces
          : "",
      weight:
        "query" in props?.location
          ? props?.location?.query?.data?.totalWeight
          : "",
      fromDeliverBoyId:
        "query" in props?.location
          ? props?.location?.query?.data?.fromDeliverBoyId
          : "",
      remarks:
        "query" in props?.location ? props?.location?.query?.data?.remarks : "",
      nextRemarks:
        "query" in props?.location
          ? props?.location?.query?.data?.nextRemarks
          : "",
      props: props?.location?.query
        ? props.location.query
        : { isEdit: 1, data: null },
      noOfCompletedPieces:
        "query" in props?.location
          ? props?.location?.query?.data?.noOfCompletedPieces
          : "",
      totalCtsDelivered:
        "query" in props?.location
          ? props?.location?.query?.data?.totalCtsDelivered
          : "",
      isModalOpen: false, // Add state for modal visibility
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
    this.toggleModal = this.toggleModal.bind(this); // Bind the modal toggle function
  }

  toggleModal() {
    this.setState(prevState => ({
      isModalOpen: !prevState.isModalOpen, // Toggle modal visibility
    }));
  }

  async handleSubmit(values) {
    this.setState({ submitDisabled: true });
    try {
      if (this.state.props.isEdit == 1) {
        // Add express inward
        values.weightType = "CT";
        let temp = {
          partyId: values.partyId,
          categoryId: values.categoryId,
          unitId: values.factoryId,
          noOfPieces: values.pieces,
          totalWeight: values.weight,
          deliveryBoyName: values.fromDeliverBoyId,
          cycle: values.cycle,
          salesRemark: values.remarks,
          createdAt: "",
          dataEntryAcceptedAt: "",
          completedAt: "",
          noOfReturnedPiecesWithoutProcessed: "",
          noOfCompletedPieces: "",
        };
  
        const data = await addSalesExpressInward(temp);
  
        if (data && data.success !== false) {
          this.setState({
            jangadId: data.data.id,
            selectedParty: {},
            submitDisabled: false, // Re-enable for next submit
          });
        } else {
          // If API failed → re-enable
          this.setState({ submitDisabled: false });
        }
      } else {
        // Update express inward
        let temp = {
          id: this.state.props.data.id,
          partyId: values.partyId,
          categoryId: values.categoryId,
          unitId: values.factoryId,
          noOfPieces: values.pieces,
          totalWeight: values.weight,
          deliveryBoyName: values.fromDeliverBoyId,
          cycle: values.cycle,
          salesRemark: values.remarks,
          createdAt: "",
          dataEntryAcceptedAt: null,
          completedAt: "",
          noOfReturnedPiecesWithoutProcessed: "",
          noOfCompletedPieces: "",
        };
  
        const data = await updateExpressInward(temp);
  
        if (data && data.success !== false) {
          this.state.history.goBack();
        } else {
          this.setState({ submitDisabled: false });
        }
      }
    } catch (error) {
      console.error("Error submitting:", error);
      this.setState({ submitDisabled: false });
    }
  }

  async componentDidMount() {
    const categories = await getCategories();
    const party = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: null,
    });
    const factory = await getUnitAPI({ isInternal: null });
    // Find HPHT category
    let defaultCategoryId = this.state.categoryId;
    if (!defaultCategoryId && Array.isArray(categories.data)) {
      const hphtCategory = categories.data.find(
        cat => cat.name && cat.name.toUpperCase() === "HPHT"
      );
      if (hphtCategory) {
        defaultCategoryId = hphtCategory.id;
      }
    }
    let defaultFactoryId = this.state.factoryId;

    if (!defaultFactoryId && Array.isArray(factory.data.factories)) {
      const sayanFactory = factory.data.factories.find(
        fac => fac.name && fac.name.toLowerCase() === "sayan"
      );
      if (sayanFactory) {
        defaultFactoryId = sayanFactory.id;
      }
    }
    this.setState({
      partyList: party.data.parties,
      factoryList: factory.data.factories,
      categoryList: categories.data,
      categoryId: defaultCategoryId ? String(defaultCategoryId) : "",
      factoryId: defaultFactoryId,
    });
    // if (this.state.props.isEdit == 2) {
    this.getDeliveryBoy();
    // }
    // Fetch stockList for view mode
    if (this.state.props.isEdit == 3 && this.state.props.data?.id) {
      const expressInward = await getExpressInwardById(
        this.state.props.data.id
      );
      // Adjust the path below if your API returns the stock list in a different property
      this.setState({
        stockList: expressInward?.data?.stocks || [],
      });
      // Fetch party outwards for OutWard To Party table
      const partyOutwards = await getPartyOutwards();
      this.setState({
        partyOutwardsList: partyOutwards?.data || [],
      });
    }
  }

  async getDeliveryBoy() {
    const deliveryBoy = await getUserApi({
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000006",
    });
    this.setState({
      deliveryBoyList: deliveryBoy.data.users,
    });
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    document.title = "sales-office";
    const { history } = this.props;
    // Prepare initialValues only once
    const initialValues =
      this.state.props.isEdit == 1
        ? {
            name: this.state.jangadId,
            partyId: this.state.selectedParty.id || "",
            categoryId: (this.state && this.state.categoryId) || "",
            factoryId: this.state.factoryId || "",
            weight: (this.state && this.state.weight) || "",
            pieces: (this.state && this.state.pieces) || "",
            fromDeliverBoyId: (this.state && this.state.fromDeliverBoyId) || "",
            cycle: (this.state && this.state.cycle) || 1,
            remarks: (this.state && this.state.salesRemark) || "",
            nextRemarks: (this.state && this.state.nextRemarks) || "",
          }
        : {
            name: this.state.props.data?.name || "",
            partyId: this.state.props.data?.partyId || "",
            categoryId: this.state.props.data?.categoryId || "",
            factoryId: this.state.props.data?.unitId || "",
            weight: this.state.props.data?.totalWeight || "",
            pieces: this.state.props.data?.noOfPieces || "",
            fromDeliverBoyId: this.state.props.data?.deliveryBoyName || "",
            cycle: this.state.props.data?.cycle || 1,
            remarks: this.state.props.data?.salesRemark || "",
            nextRemarks: this.state.props.data?.nextRemarks || "",
          };
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs
              breadcrumbItem={`${this.props.t("EXPRESS - INWARD")}`}
            />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <div className="d-lg-flex d-block justify-content-between">
                      <div>
                        <h4 className="pb-3 text-black fw-bold">
                          {`${this.props.t(
                            this.state.props.isEdit == 1
                              ? "Add Express (Inward)"
                              : this.state.props.isEdit == 3
                              ? "View Express (Inward)"
                              : "Edit Express (Inward)"
                          )}`}
                        </h4>
                      </div>
                    </div>
                    <Formik
                      enableReinitialize={true}
                      initialValues={initialValues}
                      validationSchema={Yup.object().shape({
                        factoryId: Yup.string().required(
                          "This Value is Required"
                        ),
                        categoryId: Yup.string().required(
                          "This Value is Required"
                        ),
                        weight: Yup.number()
                          .min(0)
                          .max(9223372036854775807)
                          .required("This Value is Required"),
                        pieces: Yup.number()
                          .min(1)
                          .max(2147483647)
                          .required("This Value is Required"),
                        fromDeliverBoyId: Yup.string().required(
                          "This Value is Required"
                        ),
                        cycle: Yup.number().required("This Value is Required"),
                        remarks: Yup.string()
                          .max(512)
                          .min(0)
                          .max(255)
                          .nullable()
                          .notRequired(),
                        nextremarks: Yup.string()
                          .max(512)
                          .min(0)
                          .max(255)
                          .nullable()
                          .notRequired(),
                      })}
                      onSubmit={this.handleSubmit}
                    >
                      {({
                        errors,
                        status,
                        touched,
                        values,
                        setFieldValue,
                        validateForm,
                      }) => {
                        return (
                          <Form className="needs-validation">
                            <Row>
                              <div className="col-xl-8 col-12">
                                <div className="mb-3 row">
                                  <Label
                                    htmlFor="partyId"
                                    className="col-md-2 col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t("Party")}
                                    </h5>
                                  </Label>
                                  <div className="col-md-10">
                                    <Field
                                      className={
                                        `form-control ${
                                          this.state.props.isEdit != 3
                                            ? "form-select"
                                            : ""
                                        } fs-5` +
                                        (errors.partyId && touched.partyId
                                          ? " is-invalid"
                                          : "")
                                      }
                                      name="partyId"
                                      id="partyId"
                                      as="select"
                                      disabled={this.state.props.isEdit == 3}
                                      onChange={e => {
                                        setFieldValue("partyId", e.target.value);
                                        const selectedParty = this.state.partyList.find(
                                          x => x.id === e.target.value
                                        );
                                        this.setState({
                                          selectedParty: selectedParty || {},
                                        });
                                      }}
                                    >
                                      <option value="" disabled>
                                        select
                                      </option>
                                      {this.state.partyList?.map(x => (
                                        <option key={x.id} value={x.id}>
                                          {x.partyCode} - {x.name}
                                        </option>
                                      ))}
                                    </Field>
                                    <ErrorMessage
                                      name="partyId"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </div>
                                
                                <div className="mb-3 row">
                                  <Label
                                    htmlFor="categoryId"
                                    className="col-md-2 col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t("Diamond Category")}
                                    </h5>
                                  </Label>
                                  <div className="col-md-10">
                                    <Field
                                      className={
                                        this.state.props.isEdit == 3
                                          ? "form-control fs-5" +
                                            (errors.categoryId &&
                                            touched.categoryId
                                              ? " is-invalid"
                                              : "")
                                          : "form-control form-select fs-5" +
                                            (errors.categoryId &&
                                            touched.categoryId
                                              ? " is-invalid"
                                              : "")
                                      }
                                      name="categoryId"
                                      as="select"
                                      disabled={this.state.props.isEdit == 3}
                                    >
                                      <option value="" disabled>
                                        Select
                                      </option>
                                      {this.state.categoryList?.map(x => (
                                        <option key={x.id} value={x.id}>
                                          {x.name}
                                        </option>
                                      ))}
                                    </Field>
                                    <ErrorMessage
                                      name="categoryId"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <Label
                                    htmlFor="factoryId"
                                    className="col-md-2 col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t("Unit Name")}
                                    </h5>
                                  </Label>
                                  <div className="col-md-10">
                                    <Field
                                      className={
                                        this.state.props.isEdit == 3
                                          ? "form-control fs-5" +
                                            (errors.factoryId &&
                                            touched.factoryId
                                              ? " is-invalid"
                                              : "")
                                          : "form-control form-select fs-5" +
                                            (errors.factoryId &&
                                            touched.factoryId
                                              ? " is-invalid"
                                              : "")
                                      }
                                      name="factoryId"
                                      as="select"
                                      disabled={this.state.props.isEdit == 3}
                                      onChange={e => {
                                        setFieldValue(
                                          "factoryId",
                                          e.target.value
                                        );
                                        this.getDeliveryBoy();
                                      }}
                                    >
                                      <option value="" disabled>
                                        select
                                      </option>
                                      {this.state.factoryList?.map(x => (
                                        <option value={x.id} key={x.id}>
                                          {x.name}
                                        </option>
                                      ))}
                                    </Field>
                                    <ErrorMessage
                                      name="factoryId"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <Label
                                    htmlFor="pieces"
                                    className="col-md-2 col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t("Total No of pieces")}
                                    </h5>
                                  </Label>
                                  <div className="col-md-10">
                                    <Field
                                      className={
                                        "form-control fs-5" +
                                        (errors.pieces && touched.pieces
                                          ? " is-invalid"
                                          : "")
                                      }
                                      min="0"
                                      type="number"
                                      onWheel={e => e.target.blur()}
                                      name="pieces"
                                      placeholder="No. of peices"
                                      readOnly={this.state.props.isEdit == 3}
                                    />
                                    <ErrorMessage
                                      name="pieces"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <Label
                                    htmlFor="weight"
                                    className="col-md-2 col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t("Total Weight")}
                                    </h5>
                                  </Label>
                                  <div className="col-md-10">
                                    <Field
                                      className={
                                        "form-control fs-5" +
                                        (errors.weight && touched.weight
                                          ? " is-invalid"
                                          : "")
                                      }
                                      type="number"
                                      onWheel={e => e.target.blur()}
                                      name="weight"
                                      placeholder="Total Weight"
                                      readOnly={this.state.props.isEdit == 3}
                                    />
                                    <ErrorMessage
                                      name="weight"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <Label
                                    htmlFor="fromDeliverBoyId"
                                    className="col-md-2 col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t("Delivery Boy Name")}
                                    </h5>
                                  </Label>
                                  <div className="col-md-10">
                                    <Field
                                      className={
                                        this.state.props.isEdit == 3
                                          ? "form-control fs-5" +
                                            (errors.fromDeliverBoyId &&
                                            touched.fromDeliverBoyId
                                              ? " is-invalid"
                                              : "")
                                          : "form-control form-select fs-5" +
                                            (errors.fromDeliverBoyId &&
                                            touched.fromDeliverBoyId
                                              ? " is-invalid"
                                              : "")
                                      }
                                      name="fromDeliverBoyId"
                                      as="select"
                                      disabled={this.state.props.isEdit == 3}
                                    >
                                      <option value="" disabled>
                                        select
                                      </option>
                                      {this.state.deliveryBoyList?.map(x => (
                                        <option key={x.id} value={x.id}>
                                          {x.name}
                                        </option>
                                      ))}
                                    </Field>
                                    <ErrorMessage
                                      name="fromDeliverBoyId"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <Label
                                    htmlFor="cycle"
                                    className="col-md-2 col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t("Cycle")}
                                    </h5>
                                  </Label>
                                  <div className="col-md-10">
                                    <Field
                                      className={
                                        "form-control form-select fs-5" +
                                        (errors.cycle && touched.cycle
                                          ? " is-invalid"
                                          : "")
                                      }
                                      type="number"
                                      as="select"
                                      onWheel={e => e.target.blur()}
                                      name="cycle"
                                      readOnly={true}
                                      placeholder="1"
                                    >
                                     <option value="1">1</option>
                                     <option value="2">2</option>
                                     </Field>
                                    <ErrorMessage
                                      name="cycle"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <Label
                                    htmlFor="remarks"
                                    className="col-md-2 col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t("Sales Person Remarks")}
                                    </h5>
                                  </Label>
                                  <div className="col-md-10">
                                    <Field
                                      className={
                                        "form-control fs-5" +
                                        (errors.remarks && touched.remarks
                                          ? " is-invalid"
                                          : "")
                                      }
                                      type="text"
                                      name="remarks"
                                      as="textarea"
                                      rows="5"
                                      disabled={this.state.props.isEdit == 3}
                                    />
                                    <ErrorMessage
                                      name="remarks"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-xl-4 mb-2 col-12">
                                <div className="px-4">
                                  <div className="row border-gray py-3">
                                    <div className="col-md-5 col-12 pt-2">
                                      <h5>
                                        {this.props.t("Contact Person")} :
                                      </h5>
                                    </div>
                                    <div className="col-md-7 col-12 pt-2">
                                      <h5>
                                        {this.state.props.isEdit == 1
                                          ? this.state.selectedParty
                                              .contactPersonName
                                          : this.state.props.data.party
                                              .contactPersonName}
                                      </h5>
                                    </div>
                                    <div className="col-md-5 col-12 pt-2">
                                      <h5>{this.props.t("Mobile no.1")} : </h5>
                                    </div>
                                    <div className="col-md-7 col-12 pt-2">
                                      <h5>
                                        +91{" "}
                                        {this.state.props.isEdit == 1
                                          ? this.state.selectedParty.mobileNo1
                                          : this.state.props.data.party
                                              .mobileNo1}
                                      </h5>
                                    </div>
                                    <div className="col-md-5 col-12 pt-2">
                                      <h5>{this.props.t("Mobile no.2")} : </h5>
                                    </div>
                                    <div className="col-md-7 col-12 pt-2">
                                      <h5>
                                        +91{" "}
                                        {this.state.props.isEdit == 1
                                          ? this.state.selectedParty.mobileNo2
                                          : this.state.props.data.party
                                              .mobileNo2}
                                      </h5>
                                    </div>
                                    <div className="col-md-5 col-12 pt-2">
                                      <h5>
                                        {this.props.t("Email Address")} :{" "}
                                      </h5>
                                    </div>
                                    <div className="col-md-7 col-12 pt-2">
                                      <h5>
                                        {this.state.props.isEdit == 1
                                          ? this.state.selectedParty.email
                                          : this.state.props.data.party.email}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {this.state.props.isEdit == 1 && (
                                <>
                                  <div className="col-md-12 text-end">
                                  <Button
                                      type="submit"
                                      color="primary"
                                      className="fs-4 px-5"
                                      disabled={this.state.submitDisabled}
                                    >
                                      {this.state.submitDisabled ? "Submitting..." : "Submit"}
                                    </Button>
                                  </div>
                                </>
                              )}
                              {this.state.props.isEdit == 2 && (
                                <>
                                  <div className="col-md-12 text-end">
                                    <Button
                                      type="button"
                                      color="primary"
                                      className="fs-4 px-5 me-3"
                                      onClick={() => {
                                        this.state.history.goBack();
                                      }}
                                    >
                                      Back
                                    </Button>
                                    <Button
                                      type="submit"
                                      color="primary"
                                      className="fs-4 px-5"
                                    >
                                      Update
                                    </Button>
                                  </div>
                                </>
                              )}
                            </Row>
                          </Form>
                        );
                      }}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
         
      </React.Fragment>
    );
  }
}
export default withTranslation()(AddExpressInward);
